import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import StarSupportChatbot from "./components/StarSupportChatbot";

// Pages
import Home from "./pages/Home";
import Proposer from "./pages/Proposer";
import Voter from "./pages/Voter";
import Categories from "./pages/Categories";
import Actualites from "./pages/Actualites";
import Gala from "./pages/Gala";
import Resultats from "./pages/Resultats";
import Partenaires from "./pages/Partenaires";
import CarteEtoiles from "./pages/CarteEtoiles";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";

const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE !== "false";

function MaintenancePage() {
  return (
    <div className="maintenance-shell">
      <div className="maintenance-content single-message">
        <div className="maintenance-copy centered-copy">
          <p className="maintenance-kicker">Bientôt</p>
          <h1>STERED</h1>
          <h2>AN NOZ</h2>
          <p className="maintenance-message">
            Le site ouvrira le 1er janvier.<br />
            Merci pour votre patience.
          </p>
        </div>
      </div>
    </div>
  );
}

function App() {
  if (isMaintenanceMode) {
    return (
      <div className="min-h-screen bg-obsidian">
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<MaintenancePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }

  return (
    <AuthProvider>
      <div className="min-h-screen bg-obsidian flex flex-col">
        <BrowserRouter>
          <Navbar />
          <div className="flex-1 pb-32">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/proposer" element={<Proposer />} />
              <Route path="/voter" element={<Voter />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/gala" element={<Gala />} />
              <Route path="/resultats" element={<Resultats />} />
              <Route path="/partenaires" element={<Partenaires />} />
              <Route path="/carte-etoiles" element={<CarteEtoiles />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </div>
          <Footer />
          <StarSupportChatbot />
          <Toaster position="bottom-right" theme="dark" />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
